export default __webpack_public_path__ + "static/media/850.155149e2.png";